import React from 'react'
import Loader from 'react-loader-spinner'

export const TransparentLoader = ({ tittle = "", message = "", complete=false}) => {
    return (
        <div className={"loaderTransparent" + (complete ? ' Complete' :'')}>
            <div className="loader_centerPages">
                <Loader
                    type="ThreeDots"
                    color="#0075bb"
                    height={100}
                    width={100}
                />
                <div className='message'>
                    <h1>{tittle}</h1>
                    <p>{message}</p>
                </div>
            </div>
        </div>
    )
}
